import Anmeldung from './components/Anmeldung'
import Aufmacher from './components/Aufmacher'
import FomFooter from './components/FomFooter'
import Zielgruppen from './components/Zielgruppen'
import Kopfleiste from './components/Kopfleiste'
import Lagebild from './components/Lagebild'
import Laufband from './components/Laufband'
import Partner from './components/Partner'
import Speaker from './components/Speaker'
import Studio from './components/Studio'
import Themen from './components/Themen'

/** Leitidee „Signal aus Essen“: Die Konferenz ist eine Sendung, die eine Branche im Wandel verbindet.
 *  Reihenfolge: Titel/Termin → Laufband → Haupttext + Lagebild → Partner → Themen → Speaker →
 *  Für wen → Studio → Anmeldung mit Ausweis. */
export default function App() {
  return (
    <>
      <a
        href="#anmeldung"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-xl focus:bg-white focus:px-4 focus:py-3 focus:font-bold"
      >
        Direkt zur Anmeldung
      </a>
      <Kopfleiste />
      <Aufmacher />
      <Laufband />
      <main>
        <Lagebild />
        {/* Partnerlogos direkt unter dem Haupttext, der die Partner nennt (Wunsch 06.10.2026) */}
        <Partner />
        <Themen />
        <Speaker />
        <Zielgruppen />
        <Studio />
        <Anmeldung />
      </main>
      <FomFooter />
    </>
  )
}
